import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleOrderRequestURL = `api/v1/sales-app/sales-order-request`;

//obtaining the paginated data
export const getSaleOrderRequest = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderRequestURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
//obtaining all fiscal sessions
export const getAllSaleOrderRequest = () => axiosInstance.get(`${saleOrderRequestURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleOrderRequest = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${saleOrderRequestURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

// get by id
export const getSaleOrderRequestById = (id) => axiosInstance.get(`${saleOrderRequestURL}/retrieve/${id}`);

//creating function
export const createSaleOrderRequest = (body) => axiosInstance.post(`api/v1/sales-app/sales-order/create`, body);
//updating function
export const updateSaleOrderRequest = (id, body) => axiosInstance.patch(`${saleOrderRequestURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderRequestURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
